"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Api_1 = __importDefault(require("./Api"));
class Email extends Api_1.default {
    constructor(props) {
        super(props);
    }
    /**
     * Exports the email contact for the given reference and name to the linked account given in the body.
     * @param name
     * @param ref_type
     * @param ref_id
     * @param attributes
     * @returns
     */
    exportRefContactToLinkedAccount(name, ref_type, ref_id, attributes) {
        const requestObj = {
            method: 'post',
            url: `/email/contact/${name}/${ref_type}/${ref_id}/export`,
            data: attributes,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Exports the email contact for the given name to the linked account given in the body
     * @param name
     * @param attributes
     * @returns
     */
    exportGlobalContactToLinkedAccount(name, attributes) {
        const requestObj = {
            method: 'post',
            url: `/email/contact/${name}/export`,
            data: attributes,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Returns the current email configuration for the given app
     * @param app_id
     * @returns
     */
    getAppConfiguration(app_id) {
        const requestObj = {
            method: 'get',
            url: `/email/app/${app_id}`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Return the email contact for the given reference and name
     * @param name
     * @param ref_type
     * @param ref_id
     * @returns
     */
    getContactForReference(name, ref_type, ref_id) {
        const requestObj = {
            method: 'get',
            url: `/email/contact/${name}/${ref_type}/${ref_id}`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Return the email contact for the given reference and name.
     * @param name
     * @param ref_type
     * @param ref_id
     * @returns
     */
    getContactForReferenceAsVCard(name, ref_type, ref_id) {
        const requestObj = {
            method: 'get',
            url: `/email/contact/${name}/${ref_type}/${ref_id}/vcard`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Returns the email contact for the given name. Valid names are:
     * @param name
     * @returns
     */
    getGlobalContacts(name) {
        const requestObj = {
            method: 'get',
            url: `/email/contact/${name}`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Returns the email contact as a vcard for the given name
     * @param name
     * @returns
     */
    getGlobalContactsAsVCard(name) {
        const requestObj = {
            method: 'get',
            url: `/email/contact/${name}/vcard`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Returns the subscription status for all the email groups.
     * @returns
     */
    getGroups() {
        const requestObj = {
            method: 'get',
            url: `/email/group/`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Updates the app email configuration
     * @param app_id
     * @returns
     */
    updateAppConfiguration(app_id, attributes) {
        const requestObj = {
            method: 'put',
            url: `/email/app/${app_id}`,
            data: attributes,
        };
        return this._httpRequest(requestObj);
    }
}
exports.default = Email;
